import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const CrownIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="73"
			height="73"
			viewBox="0 0 73 73"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M50.7958 57.7312H22.2042C20.9267 57.7312 19.4971 56.7275 19.0712 55.5108L6.47875 20.2883C4.68416 15.2391 6.78291 13.6879 11.1021 16.7904L22.9646 25.2766C24.9417 26.6454 27.1925 25.9458 28.0442 23.7254L33.3975 9.45996C35.1008 4.89746 37.9296 4.89746 39.6329 9.45996L44.9862 23.7254C45.8379 25.9458 48.0888 26.6454 50.0354 25.2766L61.1679 17.3379C65.9129 13.9312 68.1942 15.665 66.2475 21.1704L53.9592 55.5716C53.5029 56.7275 52.0733 57.7312 50.7958 57.7312Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19.7709 66.917H53.2292"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M28.8959 42.583H44.1042"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default memo(CrownIcon);
